import React from 'react';
import {
  StructuredTaskField,
  StructuredTaskFieldRow,
} from '../../../../common/components/StructuredTaskDetails';
import { Resource } from '../../../../common/constants/resource';
import { MIBDetails } from '../../../tasks/types/mib';
import {
  calculateAgeFromDob,
  dateToString,
  valueToString,
} from '../../utilities/formattingUtilities';

export const RenderMIBResult = (mibDetails: MIBDetails) => {
  let ageDisplay: string | number = Resource.NORA_M_DASH;
  if (mibDetails.dob) {
    const age = calculateAgeFromDob(mibDetails.dob);
    ageDisplay = Number.isNaN(age) ? Resource.NORA_M_DASH : age;
  }

  return (
    <StructuredTaskFieldRow>
      <StructuredTaskField
        label={Resource.MIB_RESULT_NAME}
        value={mibDetails.name}
      />
      <StructuredTaskField
        label={Resource.MIB_RESULT_GENDER_AND_AGE}
        value={`${mibDetails.gender}, ${ageDisplay}`}
      />
      <StructuredTaskField
        label={Resource.MIB_RESULT_BIRTH_DATE}
        value={dateToString(mibDetails.dob)}
      />
      <StructuredTaskField
        label={Resource.MIB_RESULT_BIRTH_PLACE}
        value={`${mibDetails.birthState}, ${mibDetails.birthCountry}`}
      />
      <StructuredTaskField
        label={Resource.MIB_RESULT_OCCUPATION}
        value={valueToString(mibDetails.occupation)}
      />
    </StructuredTaskFieldRow>
  );
};
